import * as z from 'zod'

import { BUNDLE_MAX_ITEMS_MAX, BUNDLE_MAX_ITEMS_MIN } from '@/common/app/modules/recommend/widget'
import { StringLength } from '@/common/form/schema'
import { WidgetLayoutType } from '@/common/model/recommend/widget'

export const visualCssSchema = z
  .object({
    useTitle: z.boolean(),
    titleTemplate: z.string().max(StringLength.NORMAL_MAX),
    layoutType: z.custom<WidgetLayoutType>(),
    maxItems: z.number().int().positive(),
    customCss: z.string().max(StringLength.TEXT_MAX),
    widgetPageId: z.number().nullable()
  })
  // バンドルの表示数は 1〜3（主商品に加えて並べる併売候補の数）
  .superRefine((data, ctx) => {
    if (
      data.layoutType === WidgetLayoutType.BUNDLE &&
      (data.maxItems < BUNDLE_MAX_ITEMS_MIN || data.maxItems > BUNDLE_MAX_ITEMS_MAX)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['maxItems'],
        message: `バンドルの表示数は${BUNDLE_MAX_ITEMS_MIN}〜${BUNDLE_MAX_ITEMS_MAX}で選んでください`
      })
    }
  })

export type VisualCssSchemaType = z.infer<typeof visualCssSchema>

export const convertVisualCssToApplyVars = (schema: VisualCssSchemaType) => ({
  custom_css: schema.customCss,
  layout_type: schema.layoutType,
  max_items: schema.maxItems,
  title_template: schema.useTitle ? schema.titleTemplate : '',
  use_title: schema.useTitle,
  widget_page_id: schema.widgetPageId
})
